namespace Areas.PunchList.Edit {
    "use strict";

    var tabItems = Areas.createTabsWithSameAction("PunchList", "Edit",
        ["Profile", "Items"]);

    export function tabInitialized(params: any) {
        return Areas.tabWithIdInitialized(tabItems)(params);
    }

    export function updatePunchListProfile() {
        const form = $("#PunchListProfileForm").dxForm("instance");
        const newData: any = form.option("formData");
        const result: any = form.validate();
        const keyId: any = form.option("KeyId");

        if (result.isValid && keyId != null) {
            sendRequest(`/PunchList/Profile/Put/${keyId}`, JSON.stringify(newData), "PUT",
                () => Areas.refreshGrid("PunchListProfilesGrid"));
        }
    }

    export function returnToListFromTab() {
        var linkInfo = "/PunchList/List/Active";
        location.href = linkInfo;

    }
}